import type { RadarListingResult } from './strategyRadarApi'
import { listingReminder } from './strategyRadarModel.ts'

export type RadarNotificationPlan = {
  id: string
  title: string
  body: string
}

export function planAnnouncementNotifications(
  items: RadarListingResult[],
  seenCodes: ReadonlySet<string>
): RadarNotificationPlan[] {
  return items
    .filter(item => item.status === 'available' && !seenCodes.has(item.code))
    .slice(0, 3)
    .map(item => ({
      id: item.code,
      title: `币安${item.kindLabel}：${assets(item)}`,
      body: item.tradingAt != null
        ? `${formatShanghai(item.tradingAt)} · 计划 Spot 时钟，仍需交易状态确认。`
        : '仅为产品 lead；未确认 Spot 交易时钟。'
    }))
}

export function planListingMilestoneNotifications(
  items: RadarListingResult[],
  seenIds: ReadonlySet<string>,
  now = Date.now()
): RadarNotificationPlan[] {
  const plans: RadarNotificationPlan[] = []
  for (const item of items) {
    if (
      item.status !== 'available'
      || item.kind === 'alpha'
      || item.tradingAt == null
      || !item.symbols.length
    ) continue

    const reminder = listingReminder(item.tradingAt, now)
    if (reminder && !(reminder.id === 'entry-window' && item.entryConfirmation.state === 'confirmed')) {
      const id = `${item.code}:${reminder.id}`
      if (!seenIds.has(id)) plans.push({
        id,
        title: `${assets(item)} · ${reminder.label}`,
        body: reminder.id === 'entry-window'
          ? `${item.entryConfirmation.label} · ${item.entryConfirmation.summary}`
          : `${formatShanghai(item.tradingAt)} · 计划时间，打开 1m 图表准备。`
      })
    }

    if (item.entryConfirmation.state === 'confirmed') {
      const id = `${item.code}:entry-confirmed:${item.entryConfirmation.dataTime ?? 'latest'}`
      if (!seenIds.has(id)) plans.push({
        id,
        title: `${assets(item)} · 1m 候选确认`,
        body: item.entryConfirmation.summary
      })
    }
  }
  return plans
}

function assets(item: RadarListingResult) {
  return item.symbols.slice(0, 3).map(symbol => symbol.replace(/(USDT|USDC|FDUSD)$/i, '')).join(' / ') || '新公告'
}

function formatShanghai(timestamp: number) {
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(new Date(timestamp)) + ' 上海'
}
